import { RootState } from "@base/store";
import Divider from "@components/atoms/divider";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import MuiButton from "@mui/material/Button";
import Link from "@mui/material/Link";
import dayjs from "dayjs";
import { ReactElement, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ReactComponent as USD } from "@assets/images/currencies/BsCurrencyDollar.svg";
import { ReactComponent as EUR } from "@assets/images/currencies/BsCurrencyEuro.svg";
import { ReactComponent as GBP } from "@assets/images/currencies/BsCurrencyPound.svg";
import { ReactComponent as AED } from "@assets/images/currencies/trade 1.svg";

import {
  ActionWrapper,
  AddToCalendarBtnWrapper,
  BtnWrapper,
  CardTexts,
  CardTitle,
  Container,
  Content,
  CurrencyWrapper,
  DetailFooterWrapper,
  EditIconWrapper,
  FeesAndCurrencyWrapper,
  FeesInfoWrapper,
  Footer,
  FooterWrapper,
  GameDetailTypography,
  Header,
  IconWrapper,
  Info,
  InfoCardButton,
  InfoWrapper,
  ShareIconWrapper,
  TitleWrapper,
  FinePrint,
} from "./transactionFee.styled";
import { ComponentProps } from "./transactionFee.type";

const TransactionFeeDisplay = ({
  game_id,
  fee,
  currency,
  isOpen,
  getGameTransactionFee,
}: ComponentProps) => {
  const [txnFee, setTxnFee] = useState<number>(-1);

  const CurrencyPriceRender = (icon: ReactElement, title: string | number) => {
    return (
      <Info>
        <Box>{icon}</Box>
        <CurrencyWrapper isPound={currency === "GBP"}>
          <Typography sx={{ wordWrap: "break-word" }}>{title}</Typography>
          {currencyRender(currency)}
        </CurrencyWrapper>
      </Info>
    );
  };

  const currencyRender = (currency: string) => {
    switch (currency) {
      case "USD":
        return <USD width={15} height={15} />;
      case "AED":
        return <AED width={15} height={15} />;
      case "GBP":
        return <GBP width={15} height={15} />;
      case "EUR":
        return <EUR width={15} height={15} />;
      default:
        break;
    }
  };


  const getFee = async (fee: number, currency: string) => {
    if (isOpen === false){
      return
    }
    const res = await getGameTransactionFee({fee:fee * 100, currency: currency, game_id: game_id});
    if (res?.meta.requestStatus === "fulfilled") {
      setTxnFee(res?.payload?.application_fee)
    }
  };

  useEffect(() => {
    getFee(fee, currency)
  }, [fee, currency, txnFee, isOpen]);

  if (isOpen === false) {
    return (
      <Container />
    )
  }

  return (
    <Container>
      <Content>
        <FinePrint fontSize="12px">Application fee (per player payment): {txnFee/100} {currency}</FinePrint>
      </Content>
    </Container>
  );
};

export default TransactionFeeDisplay;
